var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Hamburger",class:_vm.state ? 'expanded' : 'collapsed'},[_c('v-btn',{staticClass:"button",attrs:{"fab":"","text":""},on:{"click":_vm.changeState}},[_c('span',{staticClass:"bars"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }